import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

/**
 * Transforme une erreur brute (Axios / format) en Error exploitable par l’UI.
 * @param {unknown} error
 * @returns {Error}
 */
function toContentLibraryError (error) {
  if (error && error.response) {
    const status = error.response.status
    const detail = error.response.data && error.response.data.message
      ? `: ${error.response.data.message}`
      : ''
    return new Error(`Content-library request failed (${status})${detail}`)
  }
  if (error && error.request) {
    return new Error('Content-library request failed: network error')
  }
  if (error instanceof Error) {
    return error
  }
  return new Error(String(error))
}

/**
 * GET /content-library — réponse paginée Symfony { items, totalPages, ... }.
 * Aucun mock : en cas d’échec HTTP ou de format inattendu, une Error descriptive est levée.
 *
 * @returns {Promise<Array>}
 */
export async function fetchContentLibraryItems () {
  try {
    const { data } = await HTTP_HYPER_ESPACE_BACKEND.get('/content-library')
    if (!data || !Array.isArray(data.items)) {
      throw new Error('Invalid content-library response')
    }
    return data.items
  } catch (error) {
    console.error('[contentLibrary] fetchContentLibraryItems failed:', error)
    throw toContentLibraryError(error)
  }
}
